import { render, staticRenderFns } from "./client-chat-view.vue?vue&type=template&id=5adb583e&scoped=true"
import script from "./client-chat-view.vue?vue&type=script&lang=js"
export * from "./client-chat-view.vue?vue&type=script&lang=js"
import style0 from "./client-chat-view.vue?vue&type=style&index=0&id=5adb583e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb583e",
  null
  
)

export default component.exports